import tripService from '../../services/trip/tripService';
import { TripActions } from '../../types/trip.store.type';
import { ReservationGuest } from '../../types/trip.type';
import { Trip, Guests } from 'guest-data-types-ts-lib';
import ddLogger from '../../logging/ddLogger';
import { AuthUtils } from '../../utils';
import { accessTokenExpired } from './user.actions';
import { DetailedError } from '../../types/errors.type';

export function fetchTrip(shouldCleanCache = false, shouldCleanStore: boolean = false) {
    return async (dispatch: any) => {
        try {
            if (AuthUtils.isAccessTokenSessionExpired()) {
                dispatch(accessTokenExpired(true));
                return;
            }

            if (shouldCleanStore) {
                dispatch(fetchTripFromZero());
            } else {
                dispatch(fetchTripBegin());
            }

            if (shouldCleanCache) {
                try {
                    await tripService.cleanReservationCache();
                } catch (e) {
                    ddLogger.error(`ERROR invalidating cache: ${e.message}`, { error: { kind: e.message } });
                }
            }

            const trip = await tripService.getTrip();

            /* Here we could call and add addons state to redux */

            dispatch(fetchTripSuccess(trip));
        } catch (e) {
            if (e.code == 'RESERVATION_CANCELLED') {
                dispatch(setReservationIsCancelled(true));
                return;
            }
            dispatch(fetchTripError(e));
        }
    };
}

export const addGuest = (guest: ReservationGuest) => async (dispatch: any) => {
    try {
        await tripService.addGuest(guest);
        const trip = await tripService.getTrip();
        const guests = trip.guests;
        dispatch(editGuestSuccess(guests));
    } catch (e) {
        dispatch(editGuestsError(e));
    }
};

export const patchGuest = (guestId: number, guest: ReservationGuest) => async (dispatch: any) => {
    try {
        await tripService.patchGuest(guestId, guest);
        const trip = await tripService.getTrip();
        const guests = trip.guests;
        dispatch(editGuestSuccess(guests));
    } catch (e) {
        dispatch(fetchTripError(e));
    }
};

export const deleteGuest = (guestId: number) => async (dispatch: any) => {
    try {
        await tripService.deleteGuest(guestId);
        const trip = await tripService.getTrip();
        const guests = trip.guests;
        dispatch(editGuestSuccess(guests));
    } catch (e) {
        dispatch(fetchTripError(e));
    }
};

export function fetchTripBegin() {
    return {
        type: TripActions.FETCH_BEGIN,
    };
}

export function fetchTripFromZero() {
    return {
        type: TripActions.FETCH_FROM_ZERO,
    };
}

export function fetchTripSuccess(trip: Trip) {
    return {
        type: TripActions.FETCH_SUCCESS,
        payload: trip,
    };
}

export function fetchTripError(error: DetailedError) {
    return {
        type: TripActions.FETCH_ERROR,
        payload: error,
    };
}

export function editGuestSuccess(guests: Guests) {
    return {
        type: TripActions.EDIT_GUESTS_SUCCESS,
        payload: guests,
    };
}

export function editGuestsError(error: any) {
    return {
        type: TripActions.EDIT_GUESTS_ERROR,
        payload: error,
    };
}

export function setCleanCacheFlag(flag: boolean) {
    return {
        type: TripActions.SET_CLEAN_CACHE_FLAG,
        payload: flag,
    };
}

export function setEarlyCheckoutFlag(flag: boolean) {
    return {
        type: TripActions.SET_EARLY_CHECKOUT_FLAG,
        payload: flag,
    };
}

export function setIsPoolHeatAvailable(isAvailable: boolean) {
    return {
        type: TripActions.SET_IS_POOL_HEAT_AVAILABLE,
        payload: isAvailable,
    };
}

export function setReservationIsCancelled(isCancelled: boolean) {
    return {
        type: TripActions.SET_RESERVATION_IS_CANCELLED,
        payload: isCancelled,
    };
}

export function setReservationTripProtectionInfo(tripProtectionModalMessage: string) {
    return {
        type: TripActions.SET_RESERVATION_TRIP_PROTECTION_INFO,
        payload: { trip_protection_message: tripProtectionModalMessage },
    };
}
